/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"; 
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; 
import "../Our Art Canvas/OurArtCanvas.css";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

export default function OurArtCanvas() {
  return (
    <div className="Gallery-Wraps contact program gift-cards">
      <main>
        <div
          className="tp-project__area  pb-75"
          // data-background="assets/img/breadcrumb/routing.png"
          style={{ backgroundSize: "cover",backgroundImage: `url(${"assets/img/breadcrumb/routing.png"})` }}
        >
          <div className="container">
            <div className="row text">
              <div className="col-xl-12 col-lg-12 col-md-12 text-center mb-20 mt-30">
                <h4 className="text-left second">Our Art Canvas</h4>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 text-center mb-50">
                <p className="text-left-text">
                  The canvas is the foundation of the print and the screen for
                  your photo. The pigmented ink serves as a translucent layer
                  embedded on the canvas. With that said, the brighter the white
                  point the more vivid the colors. Our white point comes from
                  100% titanium white. Titanium will never discolor, fade or
                  yellow. Your print on canvas will always look the same as the
                  first day you received it.
                </p>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 text-center mb-50">
                <p className="text-left-text">
                  Our unique coating process relies on our custom designed and
                  built ink receptive coating machine. The coating applicator
                  applies an even thickness of coating and assures consistent
                  print quality. The smooth texture of our canvas enhances the
                  color, sharpness and clarity of your image. Whether it be a
                  photograph from your mobile phone or a professional camera
                  each photo on canvas prints beautifully.
                </p>
              </div>
              <div className="tp-service__area mb-30">
                <div className="container-fluid"></div>
                <div className="container-fluid slider">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="tp-service__wrapper">
                        <div className="swiper-container tp-service__active swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">
                          <div
                            // className="swiper-wrapper" 
                            id="swiper-wrapper-67b855461cc32163"
                            aria-live="polite"
                            > 
                            <Swiper
                              slidesPerView={3}
                              spaceBetween={30}
                              centeredSlides={true}
                              // pagination={{
                              //   clickable: true,
                              // }}
                              // modules={[Pagination]}
                              className="mySwiper"
                              loop                                
                             > 
                            
                            <div
                              className="swiper-slide swiper-slide-duplicate"
                              data-swiper-slide-index={2}
                              role="group"
                              aria-label="1 / 11"
                            >
                                <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-3.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                                  </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-duplicate"
                              data-swiper-slide-index={3}
                              role="group"
                              aria-label="2 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-1.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev"
                              data-swiper-slide-index={4}
                              role="group"
                              aria-label="3 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-2.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-duplicate-active"
                              data-swiper-slide-index={0}
                              role="group"
                              aria-label="4 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-1.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-duplicate-next"
                              data-swiper-slide-index={1}
                              role="group"
                              aria-label="5 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-2.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide"
                              data-swiper-slide-index={2}
                              role="group"
                              aria-label="6 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-3.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide"
                              data-swiper-slide-index={3}
                              role="group"
                              aria-label="7 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-1.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            <div
                              className="swiper-slide swiper-slide-prev"
                              data-swiper-slide-index={4}
                              role="group"
                              aria-label="8 / 11"
                            >
                              <SwiperSlide>
                              <div className="tp-service__item fix p-relative">
                                <div className="tp-service__thumb">
                                  <img
                                    src="assets/img/service/service-1-2.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              </SwiperSlide>
                            </div>
                            
                            </Swiper>
                          </div>
                          <span
                            className="swiper-notification"
                            aria-live="assertive"
                            aria-atomic="true"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center mt-20 button-uper">
                <Link to={'/create-custom-print'} className="large head banner">Create STORY CANVAS</Link> 
              </div>
            </div>
          </div>
        </div>

        <UpperFooterSlider/>

        
      </main>

    </div>
  );
}
